import { render, staticRenderFns } from "./message-file.vue?vue&type=template&id=2567b3ed&scoped=true"
import script from "./message-file.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-file.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-file.vue?vue&type=style&index=0&id=2567b3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567b3ed",
  null
  
)

export default component.exports